import script from "./ForceLogoutWarningModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForceLogoutWarningModal.vue?vue&type=script&setup=true&lang=ts"

import "./ForceLogoutWarningModal.vue?vue&type=style&index=0&id=73440041&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73440041"]])

export default __exports__